var cov_10iacy3w0z = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/lazyload.ts",
      hash = "ee2b1550916205c89f3b724a8d3b580426c25d7c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/lazyload.ts",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 17
        },
        end: {
          line: 16,
          column: 19
        }
      },
      "1": {
        start: {
          line: 17,
          column: 48
        },
        end: {
          line: 17,
          column: 50
        }
      },
      "2": {
        start: {
          line: 19,
          column: 21
        },
        end: {
          line: 19,
          column: 25
        }
      },
      "3": {
        start: {
          line: 20,
          column: 13
        },
        end: {
          line: 20,
          column: 18
        }
      },
      "4": {
        start: {
          line: 22,
          column: 18
        },
        end: {
          line: 22,
          column: 32
        }
      },
      "5": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 32,
          column: 1
        }
      },
      "6": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 29,
          column: 3
        }
      },
      "7": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 55
        }
      },
      "8": {
        start: {
          line: 27,
          column: 12
        },
        end: {
          line: 27,
          column: 55
        }
      },
      "9": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 40
        }
      },
      "10": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 31,
          column: 35
        }
      },
      "11": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 35,
          column: 20
        }
      },
      "12": {
        start: {
          line: 35,
          column: 14
        },
        end: {
          line: 35,
          column: 20
        }
      },
      "13": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 36,
          column: 15
        }
      },
      "14": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 46,
          column: 4
        }
      },
      "15": {
        start: {
          line: 40,
          column: 61
        },
        end: {
          line: 40,
          column: 74
        }
      },
      "16": {
        start: {
          line: 41,
          column: 17
        },
        end: {
          line: 41,
          column: 48
        }
      },
      "17": {
        start: {
          line: 42,
          column: 26
        },
        end: {
          line: 42,
          column: 45
        }
      },
      "18": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 100
        }
      },
      "19": {
        start: {
          line: 43,
          column: 94
        },
        end: {
          line: 43,
          column: 100
        }
      },
      "20": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 39
        }
      },
      "21": {
        start: {
          line: 44,
          column: 19
        },
        end: {
          line: 44,
          column: 39
        }
      },
      "22": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 12
        }
      },
      "23": {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 48,
          column: 16
        }
      },
      "24": {
        start: {
          line: 51,
          column: 21
        },
        end: {
          line: 58,
          column: 1
        }
      },
      "25": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 52,
          column: 36
        }
      },
      "26": {
        start: {
          line: 52,
          column: 15
        },
        end: {
          line: 52,
          column: 36
        }
      },
      "27": {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 57,
          column: 14
        }
      },
      "28": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 14
        }
      },
      "29": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 18
        }
      },
      "30": {
        start: {
          line: 61,
          column: 2
        },
        end: {
          line: 61,
          column: 36
        }
      },
      "31": {
        start: {
          line: 61,
          column: 30
        },
        end: {
          line: 61,
          column: 36
        }
      },
      "32": {
        start: {
          line: 62,
          column: 34
        },
        end: {
          line: 62,
          column: 48
        }
      },
      "33": {
        start: {
          line: 63,
          column: 19
        },
        end: {
          line: 63,
          column: 40
        }
      },
      "34": {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 68,
          column: 3
        }
      },
      "35": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 62
        }
      },
      "36": {
        start: {
          line: 65,
          column: 41
        },
        end: {
          line: 65,
          column: 62
        }
      },
      "37": {
        start: {
          line: 66,
          column: 9
        },
        end: {
          line: 68,
          column: 3
        }
      },
      "38": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 56
        }
      },
      "39": {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 69,
          column: 23
        }
      },
      "40": {
        start: {
          line: 73,
          column: 57
        },
        end: {
          line: 73,
          column: 60
        }
      },
      "41": {
        start: {
          line: 74,
          column: 19
        },
        end: {
          line: 87,
          column: 3
        }
      },
      "42": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 81,
          column: 8
        }
      },
      "43": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 80,
          column: 9
        }
      },
      "44": {
        start: {
          line: 78,
          column: 10
        },
        end: {
          line: 78,
          column: 18
        }
      },
      "45": {
        start: {
          line: 79,
          column: 10
        },
        end: {
          line: 79,
          column: 40
        }
      },
      "46": {
        start: {
          line: 79,
          column: 25
        },
        end: {
          line: 79,
          column: 40
        }
      },
      "47": {
        start: {
          line: 88,
          column: 2
        },
        end: {
          line: 88,
          column: 25
        }
      },
      "48": {
        start: {
          line: 89,
          column: 2
        },
        end: {
          line: 89,
          column: 17
        }
      },
      "49": {
        start: {
          line: 93,
          column: 13
        },
        end: {
          line: 93,
          column: 24
        }
      },
      "50": {
        start: {
          line: 94,
          column: 19
        },
        end: {
          line: 94,
          column: 44
        }
      },
      "51": {
        start: {
          line: 95,
          column: 2
        },
        end: {
          line: 95,
          column: 30
        }
      },
      "52": {
        start: {
          line: 96,
          column: 2
        },
        end: {
          line: 101,
          column: 3
        }
      },
      "53": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 24
        }
      },
      "54": {
        start: {
          line: 98,
          column: 21
        },
        end: {
          line: 98,
          column: 41
        }
      },
      "55": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 99,
          column: 33
        }
      },
      "56": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 13
        }
      },
      "57": {
        start: {
          line: 102,
          column: 2
        },
        end: {
          line: 102,
          column: 65
        }
      },
      "58": {
        start: {
          line: 103,
          column: 15
        },
        end: {
          line: 103,
          column: 50
        }
      },
      "59": {
        start: {
          line: 104,
          column: 24
        },
        end: {
          line: 104,
          column: 47
        }
      },
      "60": {
        start: {
          line: 106,
          column: 2
        },
        end: {
          line: 109,
          column: 3
        }
      },
      "61": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 24
        }
      },
      "62": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 13
        }
      },
      "63": {
        start: {
          line: 111,
          column: 2
        },
        end: {
          line: 111,
          column: 14
        }
      },
      "64": {
        start: {
          line: 112,
          column: 2
        },
        end: {
          line: 115,
          column: 3
        }
      },
      "65": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 24
        }
      },
      "66": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 13
        }
      },
      "67": {
        start: {
          line: 116,
          column: 2
        },
        end: {
          line: 116,
          column: 13
        }
      },
      "68": {
        start: {
          line: 120,
          column: 21
        },
        end: {
          line: 120,
          column: 25
        }
      },
      "69": {
        start: {
          line: 121,
          column: 2
        },
        end: {
          line: 129,
          column: 3
        }
      },
      "70": {
        start: {
          line: 122,
          column: 16
        },
        end: {
          line: 122,
          column: 20
        }
      },
      "71": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 128,
          column: 5
        }
      },
      "72": {
        start: {
          line: 124,
          column: 6
        },
        end: {
          line: 127,
          column: 18
        }
      },
      "73": {
        start: {
          line: 125,
          column: 8
        },
        end: {
          line: 125,
          column: 27
        }
      },
      "74": {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 20
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 24,
            column: 16
          },
          end: {
            line: 24,
            column: 17
          }
        },
        loc: {
          start: {
            line: 24,
            column: 33
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 24
      },
      "1": {
        name: "dispatch",
        decl: {
          start: {
            line: 34,
            column: 16
          },
          end: {
            line: 34,
            column: 24
          }
        },
        loc: {
          start: {
            line: 34,
            column: 27
          },
          end: {
            line: 49,
            column: 1
          }
        },
        line: 34
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 39,
            column: 34
          },
          end: {
            line: 39,
            column: 35
          }
        },
        loc: {
          start: {
            line: 39,
            column: 39
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 39
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 51,
            column: 21
          },
          end: {
            line: 51,
            column: 22
          }
        },
        loc: {
          start: {
            line: 51,
            column: 27
          },
          end: {
            line: 58,
            column: 1
          }
        },
        line: 51
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 54,
            column: 23
          },
          end: {
            line: 54,
            column: 24
          }
        },
        loc: {
          start: {
            line: 54,
            column: 29
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 54
      },
      "5": {
        name: "removeStack",
        decl: {
          start: {
            line: 60,
            column: 16
          },
          end: {
            line: 60,
            column: 27
          }
        },
        loc: {
          start: {
            line: 60,
            column: 74
          },
          end: {
            line: 70,
            column: 1
          }
        },
        line: 60
      },
      "6": {
        name: "getObserver",
        decl: {
          start: {
            line: 72,
            column: 9
          },
          end: {
            line: 72,
            column: 20
          }
        },
        loc: {
          start: {
            line: 72,
            column: 50
          },
          end: {
            line: 90,
            column: 1
          }
        },
        line: 72
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        },
        loc: {
          start: {
            line: 75,
            column: 15
          },
          end: {
            line: 82,
            column: 5
          }
        },
        line: 75
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 76,
            column: 22
          },
          end: {
            line: 76,
            column: 23
          }
        },
        loc: {
          start: {
            line: 76,
            column: 28
          },
          end: {
            line: 81,
            column: 7
          }
        },
        line: 76
      },
      "9": {
        name: "addStack",
        decl: {
          start: {
            line: 92,
            column: 16
          },
          end: {
            line: 92,
            column: 24
          }
        },
        loc: {
          start: {
            line: 92,
            column: 42
          },
          end: {
            line: 117,
            column: 1
          }
        },
        line: 92
      },
      "10": {
        name: "throttleWrapper",
        decl: {
          start: {
            line: 119,
            column: 16
          },
          end: {
            line: 119,
            column: 31
          }
        },
        loc: {
          start: {
            line: 119,
            column: 46
          },
          end: {
            line: 130,
            column: 1
          }
        },
        line: 119
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 121,
            column: 9
          },
          end: {
            line: 121,
            column: 10
          }
        },
        loc: {
          start: {
            line: 121,
            column: 29
          },
          end: {
            line: 129,
            column: 3
          }
        },
        line: 121
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 124,
            column: 25
          },
          end: {
            line: 124,
            column: 26
          }
        },
        loc: {
          start: {
            line: 124,
            column: 31
          },
          end: {
            line: 127,
            column: 7
          }
        },
        line: 124
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        }, {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 26,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 26,
            column: 9
          }
        }, {
          start: {
            line: 26,
            column: 13
          },
          end: {
            line: 26,
            column: 38
          }
        }],
        line: 26
      },
      "2": {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 55
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 55
          }
        }],
        line: 27
      },
      "3": {
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 35,
            column: 20
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 35,
            column: 20
          }
        }, {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 35,
            column: 20
          }
        }],
        line: 35
      },
      "4": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 100
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 100
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 100
          }
        }],
        line: 43
      },
      "5": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 48
          }
        }, {
          start: {
            line: 43,
            column: 52
          },
          end: {
            line: 43,
            column: 92
          }
        }],
        line: 43
      },
      "6": {
        loc: {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 39
          }
        }, {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 39
          }
        }],
        line: 44
      },
      "7": {
        loc: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 36
          }
        }, {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 36
          }
        }],
        line: 52
      },
      "8": {
        loc: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 36
          }
        }, {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 36
          }
        }],
        line: 61
      },
      "9": {
        loc: {
          start: {
            line: 61,
            column: 6
          },
          end: {
            line: 61,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 6
          },
          end: {
            line: 61,
            column: 9
          }
        }, {
          start: {
            line: 61,
            column: 13
          },
          end: {
            line: 61,
            column: 28
          }
        }],
        line: 61
      },
      "10": {
        loc: {
          start: {
            line: 63,
            column: 19
          },
          end: {
            line: 63,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 19
          },
          end: {
            line: 63,
            column: 28
          }
        }, {
          start: {
            line: 63,
            column: 32
          },
          end: {
            line: 63,
            column: 40
          }
        }],
        line: 63
      },
      "11": {
        loc: {
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        }, {
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        }],
        line: 64
      },
      "12": {
        loc: {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 62
          }
        }, {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 62
          }
        }],
        line: 65
      },
      "13": {
        loc: {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 65,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 65,
            column: 16
          }
        }, {
          start: {
            line: 65,
            column: 20
          },
          end: {
            line: 65,
            column: 39
          }
        }],
        line: 65
      },
      "14": {
        loc: {
          start: {
            line: 66,
            column: 9
          },
          end: {
            line: 68,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 9
          },
          end: {
            line: 68,
            column: 3
          }
        }, {
          start: {
            line: 66,
            column: 9
          },
          end: {
            line: 68,
            column: 3
          }
        }],
        line: 66
      },
      "15": {
        loc: {
          start: {
            line: 73,
            column: 10
          },
          end: {
            line: 73,
            column: 26
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 73,
            column: 22
          },
          end: {
            line: 73,
            column: 26
          }
        }],
        line: 73
      },
      "16": {
        loc: {
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 80,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 80,
            column: 9
          }
        }, {
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 80,
            column: 9
          }
        }],
        line: 77
      },
      "17": {
        loc: {
          start: {
            line: 77,
            column: 12
          },
          end: {
            line: 77,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 12
          },
          end: {
            line: 77,
            column: 29
          }
        }, {
          start: {
            line: 77,
            column: 33
          },
          end: {
            line: 77,
            column: 57
          }
        }],
        line: 77
      },
      "18": {
        loc: {
          start: {
            line: 79,
            column: 10
          },
          end: {
            line: 79,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 10
          },
          end: {
            line: 79,
            column: 40
          }
        }, {
          start: {
            line: 79,
            column: 10
          },
          end: {
            line: 79,
            column: 40
          }
        }],
        line: 79
      },
      "19": {
        loc: {
          start: {
            line: 94,
            column: 19
          },
          end: {
            line: 94,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 94,
            column: 19
          },
          end: {
            line: 94,
            column: 32
          }
        }, {
          start: {
            line: 94,
            column: 36
          },
          end: {
            line: 94,
            column: 44
          }
        }],
        line: 94
      },
      "20": {
        loc: {
          start: {
            line: 95,
            column: 15
          },
          end: {
            line: 95,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 95,
            column: 15
          },
          end: {
            line: 95,
            column: 25
          }
        }, {
          start: {
            line: 95,
            column: 29
          },
          end: {
            line: 95,
            column: 30
          }
        }],
        line: 95
      },
      "21": {
        loc: {
          start: {
            line: 96,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 96,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        }, {
          start: {
            line: 96,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        }],
        line: 96
      },
      "22": {
        loc: {
          start: {
            line: 106,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        }, {
          start: {
            line: 106,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        }],
        line: 106
      },
      "23": {
        loc: {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 106,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 106,
            column: 50
          }
        }, {
          start: {
            line: 106,
            column: 54
          },
          end: {
            line: 106,
            column: 98
          }
        }],
        line: 106
      },
      "24": {
        loc: {
          start: {
            line: 112,
            column: 2
          },
          end: {
            line: 115,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 112,
            column: 2
          },
          end: {
            line: 115,
            column: 3
          }
        }, {
          start: {
            line: 112,
            column: 2
          },
          end: {
            line: 115,
            column: 3
          }
        }],
        line: 112
      },
      "25": {
        loc: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        }, {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        }],
        line: 123
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { eventPassive } from './dom/detect';
import { getUidStr } from './uid';
import { docSize } from './dom/document';
var throttle = (cov_10iacy3w0z.s[0]++, 80);
var components = (cov_10iacy3w0z.s[1]++, {});
var timeout = (cov_10iacy3w0z.s[2]++, null);
var isLock = (cov_10iacy3w0z.s[3]++, false);
var winHeight = (cov_10iacy3w0z.s[4]++, docSize.height);
cov_10iacy3w0z.s[5]++;

var getRect = function getRect(el) {
  cov_10iacy3w0z.f[0]++;
  cov_10iacy3w0z.s[6]++;

  // document or invalid element
  if ((cov_10iacy3w0z.b[1][0]++, !el) || (cov_10iacy3w0z.b[1][1]++, !el.getBoundingClientRect)) {
    cov_10iacy3w0z.b[0][0]++;
    cov_10iacy3w0z.s[7]++;

    if (el) {
      cov_10iacy3w0z.b[2][0]++;
      cov_10iacy3w0z.s[8]++;
      console.error("the ".concat(el, " is not a element"));
    } else {
      cov_10iacy3w0z.b[2][1]++;
    }

    cov_10iacy3w0z.s[9]++;
    return {
      top: 0,
      bottom: winHeight
    };
  } else {
    cov_10iacy3w0z.b[0][1]++;
  }

  cov_10iacy3w0z.s[10]++;
  return el.getBoundingClientRect();
};

export function dispatch() {
  cov_10iacy3w0z.f[1]++;
  cov_10iacy3w0z.s[11]++;

  if (isLock) {
    cov_10iacy3w0z.b[3][0]++;
    cov_10iacy3w0z.s[12]++;
    return;
  } else {
    cov_10iacy3w0z.b[3][1]++;
  }

  cov_10iacy3w0z.s[13]++;
  isLock = true; // handle

  cov_10iacy3w0z.s[14]++;
  Object.keys(components).forEach(function (k) {
    cov_10iacy3w0z.f[2]++;

    var _ref = (cov_10iacy3w0z.s[15]++, components[k]),
        element = _ref.element,
        render = _ref.render,
        container = _ref.container,
        offset = _ref.offset,
        noRemove = _ref.noRemove;

    var rect = (cov_10iacy3w0z.s[16]++, element.getBoundingClientRect());
    var containerRect = (cov_10iacy3w0z.s[17]++, getRect(container));
    cov_10iacy3w0z.s[18]++;

    if ((cov_10iacy3w0z.b[5][0]++, rect.bottom + offset < containerRect.top) || (cov_10iacy3w0z.b[5][1]++, rect.top - offset > containerRect.bottom)) {
      cov_10iacy3w0z.b[4][0]++;
      cov_10iacy3w0z.s[19]++;
      return;
    } else {
      cov_10iacy3w0z.b[4][1]++;
    }

    cov_10iacy3w0z.s[20]++;

    if (!noRemove) {
      cov_10iacy3w0z.b[6][0]++;
      cov_10iacy3w0z.s[21]++;
      delete components[k];
    } else {
      cov_10iacy3w0z.b[6][1]++;
    }

    cov_10iacy3w0z.s[22]++;
    render();
  });
  cov_10iacy3w0z.s[23]++;
  isLock = false;
}
cov_10iacy3w0z.s[24]++;

var handleScroll = function handleScroll() {
  cov_10iacy3w0z.f[3]++;
  cov_10iacy3w0z.s[25]++;

  if (timeout) {
    cov_10iacy3w0z.b[7][0]++;
    cov_10iacy3w0z.s[26]++;
    clearTimeout(timeout);
  } else {
    cov_10iacy3w0z.b[7][1]++;
  }

  cov_10iacy3w0z.s[27]++;
  timeout = setTimeout(function () {
    cov_10iacy3w0z.f[4]++;
    cov_10iacy3w0z.s[28]++;
    dispatch();
    cov_10iacy3w0z.s[29]++;
    timeout = null;
  }, throttle);
};

export function removeStack(id, removeListener) {
  cov_10iacy3w0z.f[5]++;
  cov_10iacy3w0z.s[30]++;

  if ((cov_10iacy3w0z.b[9][0]++, !id) || (cov_10iacy3w0z.b[9][1]++, !components[id])) {
    cov_10iacy3w0z.b[8][0]++;
    cov_10iacy3w0z.s[31]++;
    return;
  } else {
    cov_10iacy3w0z.b[8][1]++;
  }

  var _ref2 = (cov_10iacy3w0z.s[32]++, components[id]),
      observer = _ref2.observer,
      container = _ref2.container;

  var scrollEl = (cov_10iacy3w0z.s[33]++, (cov_10iacy3w0z.b[10][0]++, container) || (cov_10iacy3w0z.b[10][1]++, document));
  cov_10iacy3w0z.s[34]++;

  if (window.IntersectionObserver) {
    cov_10iacy3w0z.b[11][0]++;
    cov_10iacy3w0z.s[35]++;

    if ((cov_10iacy3w0z.b[13][0]++, observer) && (cov_10iacy3w0z.b[13][1]++, observer.disconnect)) {
      cov_10iacy3w0z.b[12][0]++;
      cov_10iacy3w0z.s[36]++;
      observer.disconnect();
    } else {
      cov_10iacy3w0z.b[12][1]++;
    }
  } else {
    cov_10iacy3w0z.b[11][1]++;
    cov_10iacy3w0z.s[37]++;

    if (removeListener) {
      cov_10iacy3w0z.b[14][0]++;
      cov_10iacy3w0z.s[38]++;
      scrollEl.removeEventListener('scroll', handleScroll);
    } else {
      cov_10iacy3w0z.b[14][1]++;
    }
  }

  cov_10iacy3w0z.s[39]++;
  delete components[id];
}

function getObserver(obj, id) {
  cov_10iacy3w0z.f[6]++;

  var _ref3 = (cov_10iacy3w0z.s[40]++, obj),
      _ref3$container = _ref3.container,
      container = _ref3$container === void 0 ? (cov_10iacy3w0z.b[15][0]++, null) : _ref3$container,
      offset = _ref3.offset,
      render = _ref3.render,
      noRemove = _ref3.noRemove;

  var observer = (cov_10iacy3w0z.s[41]++, new IntersectionObserver(function (entries) {
    cov_10iacy3w0z.f[7]++;
    cov_10iacy3w0z.s[42]++;
    entries.forEach(function (en) {
      cov_10iacy3w0z.f[8]++;
      cov_10iacy3w0z.s[43]++;

      if ((cov_10iacy3w0z.b[17][0]++, en.isIntersecting) || (cov_10iacy3w0z.b[17][1]++, en.intersectionRatio > 0)) {
        cov_10iacy3w0z.b[16][0]++;
        cov_10iacy3w0z.s[44]++;
        render();
        cov_10iacy3w0z.s[45]++;

        if (!noRemove) {
          cov_10iacy3w0z.b[18][0]++;
          cov_10iacy3w0z.s[46]++;
          removeStack(id);
        } else {
          cov_10iacy3w0z.b[18][1]++;
        }
      } else {
        cov_10iacy3w0z.b[16][1]++;
      }
    });
  }, {
    root: container,
    rootMargin: "".concat(offset, "px")
  }));
  cov_10iacy3w0z.s[47]++;
  obj.observer = observer;
  cov_10iacy3w0z.s[48]++;
  return observer;
}

export function addStack(obj) {
  cov_10iacy3w0z.f[9]++;
  var id = (cov_10iacy3w0z.s[49]++, getUidStr());
  var scrollEl = (cov_10iacy3w0z.s[50]++, (cov_10iacy3w0z.b[19][0]++, obj.container) || (cov_10iacy3w0z.b[19][1]++, document));
  cov_10iacy3w0z.s[51]++;
  obj.offset = (cov_10iacy3w0z.b[20][0]++, obj.offset) || (cov_10iacy3w0z.b[20][1]++, 0);
  cov_10iacy3w0z.s[52]++;

  if (window.IntersectionObserver) {
    cov_10iacy3w0z.b[21][0]++;
    cov_10iacy3w0z.s[53]++;
    components[id] = obj;

    var _observer = (cov_10iacy3w0z.s[54]++, getObserver(obj, id));

    cov_10iacy3w0z.s[55]++;

    _observer.observe(obj.element);

    cov_10iacy3w0z.s[56]++;
    return id;
  } else {
    cov_10iacy3w0z.b[21][1]++;
  }

  cov_10iacy3w0z.s[57]++;
  scrollEl.addEventListener('scroll', handleScroll, eventPassive);
  var rect = (cov_10iacy3w0z.s[58]++, obj.element.getBoundingClientRect());
  var containerRect = (cov_10iacy3w0z.s[59]++, getRect(obj.container));
  cov_10iacy3w0z.s[60]++;

  if ((cov_10iacy3w0z.b[23][0]++, rect.bottom + obj.offset < containerRect.top) || (cov_10iacy3w0z.b[23][1]++, rect.top - obj.offset > containerRect.bottom)) {
    cov_10iacy3w0z.b[22][0]++;
    cov_10iacy3w0z.s[61]++;
    components[id] = obj;
    cov_10iacy3w0z.s[62]++;
    return id;
  } else {
    cov_10iacy3w0z.b[22][1]++;
  }

  cov_10iacy3w0z.s[63]++;
  obj.render();
  cov_10iacy3w0z.s[64]++;

  if (obj.noRemove) {
    cov_10iacy3w0z.b[24][0]++;
    cov_10iacy3w0z.s[65]++;
    components[id] = obj;
    cov_10iacy3w0z.s[66]++;
    return id;
  } else {
    cov_10iacy3w0z.b[24][1]++;
  }

  cov_10iacy3w0z.s[67]++;
  return null;
}
export function throttleWrapper(cb) {
  var _this = this;

  cov_10iacy3w0z.f[10]++;
  var timer = (cov_10iacy3w0z.s[68]++, null);
  cov_10iacy3w0z.s[69]++;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    cov_10iacy3w0z.f[11]++;
    var ctx = (cov_10iacy3w0z.s[70]++, _this);
    cov_10iacy3w0z.s[71]++;

    if (!timer) {
      cov_10iacy3w0z.b[25][0]++;
      cov_10iacy3w0z.s[72]++;
      timer = setTimeout(function () {
        cov_10iacy3w0z.f[12]++;
        cov_10iacy3w0z.s[73]++;
        cb.apply(ctx, args);
        cov_10iacy3w0z.s[74]++;
        timer = null;
      }, throttle);
    } else {
      cov_10iacy3w0z.b[25][1]++;
    }
  };
}